module.exports = __webpack_public_path__ + "img/labBg2.724ea8ca.png";